// the shop's calendar: the server renders in UTC and the reader's browser in
// its own zone, so "today" is read in one zone for both — or the page the
// server sends and the one the browser draws name different days
const SHOP_TIME_ZONE = "Europe/Sofia"

/** Today in the shop's time zone, as a UTC midnight date (calendar math only). */
function shopToday() {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: SHOP_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date())
  const get = (type) => Number(parts.find((p) => p.type === type)?.value)
  return new Date(Date.UTC(get("year"), get("month") - 1, get("day")))
}

/** Date `businessDays` working days from today, localized (same rule as the product page) */
export function expectedDelivery(businessDays, locale, format = { weekday: "long", year: "numeric", month: "long", day: "numeric" }) {
  const date = shopToday()
  let added = 0
  while (added < businessDays) {
    date.setUTCDate(date.getUTCDate() + 1)
    const day = date.getUTCDay()
    if (day !== 0 && day !== 6) added++
  }
  return date.toLocaleDateString(locale || undefined, { ...format, timeZone: "UTC" })
}
